export const ISubsidiaryLedger = {
  id: 104,
  account_name: 'General Expenses',
  account_type: 21,
  is_auto_generated: true,
  currency_code: 'gbp',
  subsidiary_ledger: 201,
  subledger: 0,
}
